import React from "react";
import { Car } from "lucide-react";
import { Section, SectionTitle } from "./Section";
import { SIZE_LABELS, formatMoney, panelUnitPrice } from "@/lib/pricing";

const SIZE_CARD = {
  small: "data-[on=true]:border-sky-400 data-[on=true]:bg-sky-500/10 data-[on=true]:shadow-[0_0_25px_-6px_rgba(56,189,248,0.6)]",
  medium: "data-[on=true]:border-amber-400 data-[on=true]:bg-amber-500/10 data-[on=true]:shadow-[0_0_25px_-6px_rgba(245,158,11,0.6)]",
  large: "data-[on=true]:border-orange-400 data-[on=true]:bg-orange-500/10 data-[on=true]:shadow-[0_0_25px_-6px_rgba(249,115,22,0.6)]",
};

export default function SizeSelector({ size, onChange, settings, sym }) {
  const hint = (k) =>
    settings.pricing_mode === "manual"
      ? `Door ${formatMoney(sym, panelUnitPrice(settings, settings.panels[0], k))}`
      : `×${settings.size_multipliers[k]}`;

  return (
    <Section>
      <SectionTitle n="1" en="Vehicle Size" zh="车型尺寸" icon={Car} />
      <div className="grid grid-cols-3 gap-3 mt-4">
        {Object.entries(SIZE_LABELS).map(([k, v]) => (
          <button key={k} data-on={size === k} onClick={() => onChange(k)} data-testid={`size-selector-${k}-btn`}
            className={`text-left rounded-xl border-2 border-slate-700 bg-slate-900/50 p-3 sm:p-4 transition-all duration-200 hover:border-slate-500 active:scale-[0.98] ${SIZE_CARD[k]}`}>
            <div className="font-heading font-extrabold text-base sm:text-lg">{v.en}</div>
            <div className="font-zh text-amber-300/80 text-sm">{v.zh}</div>
            <div className="text-[10px] sm:text-xs text-slate-500 mt-1 leading-tight">{v.sub}</div>
            <div className="font-mono-num text-xs text-slate-400 mt-2">{hint(k)}</div>
          </button>
        ))}
      </div>
    </Section>
  );
}
